export default "__VITE_ASSET__51f20372__"